import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationHttpClient } from '@app/core/http';

import { IsurranceDepartment } from '@app/core/models';


@Injectable({ providedIn: 'root' })
export class IsurranceDepartmentService {

  constructor(private http: ApplicationHttpClient) {
  }
  
  public getIsurranceDepartments(cityId: string): Observable<IsurranceDepartment> {
    return this.http.get(`/api/app/isurrance-department/city?cityCode=${ cityId }`, {
    });
  }
  
  public getDetailById(id: string) {
    return this.http.get(`/api/app/isurrance-department/${id}`);
  }

  public getDetailByCode(code: string) {
    return this.http.get(`/api/app/isurrance-department/code?code=${code}`);
  }
  
}
